// Module
var code = `<div ng-if="entityLabelController.entity.type === 'evaluation'"> <a class="link-button" ui-sref="evaluation.general({ id: entityLabelController.entity.id })" translate> Generic.Evaluations </a> </div> `;
// Exports
module.exports = code;